<script>
	import { onMount, createEventDispatcher } from 'svelte';
  import * as doT from 'doT';
	import { fade } from 'svelte/transition';
	import { save, refresh, trash, print as printIcon, arrowRoundBack } from 'ionicons/icons/index.mjs';
  import { generateID, fetchData } from '../utils/Data.svelte';

	const dispatch = createEventDispatcher();
  export let modal;
  export let tooltips;
  export let session;
  export let mode;
  let result = null;

  onMount(() => {
      var tempFn = doT.default.template(modal.template.text);
      var properties = {};
      if (modal.features)
          properties = this.parent.gridOptions.rowData;
      else if (modal.feature)
          properties = modal.feature;
      result = tempFn(properties);
  });

	function sendMessage(message) {
		dispatch('message', message);
	}

  function close() {
		dispatch('message', {
            type: "modal",
            modal: null
		});
  }

  async function saveHandler(e) {
		e.currentTarget.blur();
    console.log(modal);
    
    var path = "/summary/" + modal.layer + "/" + modal.feature_id;
    console.log(path)
    let [res, err]  = await fetchData("/v1/media" + path, {
        method: "POST",
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + session.token
        },
        body: JSON.stringify({
          filename: generateID() + ".html",
          name: modal.template.name + " " + new Date().toISOString(),
          summary: result
        })
    });
    console.log(err);
    dispatch('message', {
        type: "toast",
        data: {
            message: "Summary saved."
        }
    });
    if (modal.back) {
      sendMessage({
        type: "modal",
        data: modal.back
      })
    }
    else {
      close();
    }
  }

  function printHandler(e) {
		e.currentTarget.blur();
    print("summary");
  }

  function deferred() {
    let thens = []
    let catches = []
  
    let status
    let resolvedValue
    let rejectedError
  
    return {
      resolve: value => {
        status = 'resolved'
        resolvedValue = value
        thens.forEach(t => t(value))
        thens = [] // Avoid memleaks.
      },
      reject: error => {
        status = 'rejected'
        rejectedError = error
        catches.forEach(c => c(error))
        catches = [] // Avoid memleaks.
      },
      then: cb => {
        if (status === 'resolved') {
          cb(resolvedValue)
        } else {
          thens.unshift(cb)
        }
      },
      catch: cb => {
        if (status === 'rejected') {
          cb(rejectedError)
        } else {
          catches.unshift(cb)
        }
      },
    }
  }

  function printFrame(frameWindow, content, options) {
      // Print the selected window/iframe
      var def = deferred();
      try {
          frameWindow = frameWindow.contentWindow || frameWindow.contentDocument || frameWindow;
          frameWindow.open();
          if (frameWindow.write) {
            frameWindow.write(content);
          }
          else {
            frameWindow.document.write(content);
          }
          frameWindow.close();
          var printed = false,
          callPrint = function () {
              if (printed) {
                  return;
              }
              // Fix for IE : Allow it to render the iframe
              frameWindow.focus();
              try {
                  // Fix for IE11 - printng the whole page instead of the iframe content
                  if (!frameWindow.document.execCommand('print', false, null)) {
                      // document.execCommand returns false if it failed -http://stackoverflow.com/a/21336448/937891
                      frameWindow.print();
                  }
                  // focus body as it is losing focus in iPad and content not getting printed
                  document.querySelector('body').focus();
              } catch (e) {
                console.log(e);
                  frameWindow.print();
              }
              frameWindow.close();
              printed = true;
              def.resolve();
          };
          frameWindow.addEventListener("load", callPrint);
          setTimeout(callPrint, options.timeout);
      } catch (err) {
        def.reject(err);
      }
      return def;
  }

  function printContentInIFrame(content, options) {
      var iframe = document.createElement('iframe');
      iframe.setAttribute("style", "height:0;width:0;border:0;position:absolute;top:-999;left:-999;");
      document.querySelector("body").appendChild(iframe);
      return printFrame(iframe, content, options);
  }

  function printContentInNewWindow(content, options) {
      // Open a new window and print selected content
      var frameWindow = window.open();
      return printFrame(frameWindow, content, options);
  }

  function print(id, options) {
      // Print a given set of elements
      var element = document.getElementById(id);
      
      // Default options
      var defaults = {
          iframe: true,
          timeout: 750
      };
      // Merge with user-options
      options = {...defaults, ...options};

      // Create a copy of the element to print
      var copy = element.cloneNode(true);
      // Wrap it in a span to get the HTML markup string
      copy = document.createElement('span').appendChild(copy);

      if (options.iframe) {
          // Use an iframe for printing
          try {
              printContentInIFrame(copy.innerHTML, options);
          } catch (e) {
              console.log(e);
              printContentInNewWindow(copy.innerHTML, options);
          }
      } else {
          // Use a new window for printing
          printContentInNewWindow(copy.innerHTML, options);
      }
      return this;
  };
</script>

<div class="modal modal-lg active">
    <div class="modal-overlay" on:click={close} aria-label="Close"></div>
    <div id="modal-container" class="modal-container">
        <div class="modal-header">
            <div class="tile tile-centered">
                <div class="tile-content">
                    <div class="tile-title">Summary</div>
                </div>
                <div class="tile-action">
                  {#if mode != "embed"}
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Save" on:click={saveHandler} aria-label="Save"><i class="svg svg-light">{@html save.md}</i></button>
                  {/if}
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Print" on:click={printHandler} aria-label="Print"><i class="svg svg-light">{@html printIcon.md}</i></button>
                    {#if modal.back}
                        <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Back" on:click|stopPropagation={(e) => {
                          e.currentTarget.blur();
                          sendMessage({
                            type: "modal",
                            data: modal.back
                          })
                        }} aria-label="Back"><i class="svg svg-light">{@html arrowRoundBack.md}</i></button>
                    {/if}
                    <button class="btn btn-link {tooltips ? "tooltip tooltip-left" : ""}" data-tooltip="Close" on:click={close} aria-label="Close"><i class="icon icon-cross mt-1"></i></button>
                </div>
            </div>
        </div>
        <div id="summary" class="modal-body">
           {#if result}
              {@html result }
           {/if}
        </div>
    </div>
</div>

<style>
	.modal.modal-lg .modal-overlay {
        background: rgba(247, 248, 249, 0.75);
    }
    .modal.modal-lg .modal-container {
        height: 100vh;
        height: calc(var(--vh, 1vh) * 100);
        padding: 0;
    }
    .modal.modal-lg .modal-header {
        background-color: #00ab5f;
        color: #fff;
        padding: 0.2rem 0.4rem;
    }
    .modal.modal-lg .modal-header .btn.btn-link {
        color: white;
    }
    .modal.modal-lg .modal-body {
        padding: 0;
        height: calc(100vh - 2.1rem);
    }
    ::-webkit-scrollbar {
      width: 6px;
      background-color: #f7f8f9;
    }
	  ::-webkit-scrollbar-thumb {
	  	background-color: rgba(122,129,132, 1);
    }
</style>